export default __webpack_public_path__ + "static/img1-bb8cf5a8a49a25cbe81615f627573fec.png";